import gpsApiService from "../../api/raily/gps/gps-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import GpsCargoOrderRecord from "./cargo-order-records/gps-cargo-order-records";
import GpsCargoOrderRecordsError from "./cargo-order-records/gps-cargo-order-records-error";
import GpsCargoOrderRecordsParams from "./cargo-order-records/gps-cargo-order-records-params";
import gpsCargoOrderRecordsParamsFactory from "./cargo-order-records/gps-cargo-order-records-params.factory";
import gpsCargoOrderRecordsFactory from "./cargo-order-records/gps-cargo-order-records.factory";
import GpsPlanEntryRecords from "./plan-entry-records/gps-plan-entry-records";
import GpsPlanEntryRecordsError from "./plan-entry-records/gps-plan-entry-records-error";
import GpsPlanEntryRecordsParams from "./plan-entry-records/gps-plan-entry-records-params";
import gpsPlanEntryRecordsParamsFactory from "./plan-entry-records/gps-plan-entry-records-params.factory";
import gpsPlanEntryRecordsFactory from "./plan-entry-records/gps-plan-entry-records.factory";

const getCargoOrderRecords = async (
  params: GpsCargoOrderRecordsParams,
  abortSignal: AbortSignal,
): Promise<GpsCargoOrderRecord[]> => {
  const request = gpsCargoOrderRecordsParamsFactory.create(params);

  try {
    const response = await gpsApiService().getCargoOrderRecords(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return gpsCargoOrderRecordsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | GpsCargoOrderRecordsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getPlanEntryRecords = async (
  params: GpsPlanEntryRecordsParams,
  abortSignal: AbortSignal,
): Promise<GpsPlanEntryRecords> => {
  const request = gpsPlanEntryRecordsParamsFactory.create(params);

  try {
    const response = await gpsApiService().getPlanEntryRecords(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    return gpsPlanEntryRecordsFactory.create(response);
  } catch (_error) {
    const error = _error as HttpError | GpsPlanEntryRecordsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const gpsService = {
  getCargoOrderRecords,
  getPlanEntryRecords,
};

export default gpsService;
